import { Component, OnInit } from '@angular/core';
import { ToastMensajeService } from '../../services/mensaje-toast.service';

@Component({
  selector: 'app-toast-mensaje',
  templateUrl: './toast-mensaje.component.html',
  styleUrls: ['./toast-mensaje.component.scss']
})
export class ToastMensajeComponent implements OnInit {

  constructor(public toastService: ToastMensajeService) {}

  ngOnInit(): void {
  }

}
